import tinycolor from 'tinycolor2';

/**
 * Convert a colour to a colour with specified alpha
 */
export const getColourWithAlpha = (colour: string, alpha: number) => {
  const stripColourInstance = tinycolor(colour);
  stripColourInstance.setAlpha(alpha);
  return stripColourInstance.toRgbString();
};

export const getBackgroundColourForColour = (colour: string) => {
  const hsl = tinycolor(colour).toHsl();
  hsl.s = 20;
  hsl.l = 95;

  return tinycolor(hsl).toHslString();
};

export const getAdjustedReadableTextColourForBackground = (
  colour: string,
  backgroundColour: string
) => {
  // check is colour readable on background
  const isReadable = tinycolor.isReadable(colour, backgroundColour, {});

  if (isReadable) {
    return colour;
  }

  const isBackgroundLight = tinycolor(backgroundColour).isLight();
  if (isBackgroundLight) {
    // background is light, so darken text
    const darkenedColour = tinycolor(colour).darken(10).toString();
    return darkenedColour;
  }
  const lightenedColour = tinycolor(colour).lighten(10).toString();
  return lightenedColour;
};

/**
 * Get the most readable text colour for a given background colour
 */
export const getReadableTextColour = (
  colour: string,
  // Todo: replace with our design system colours when available
  colourList = [
    // our blue scale
    '#1D2540',
    '#23304F',
    '#2A3C5F',
    '#30496E',
    '#36577D',
    '#55769B',
    '#7796B6',
    '#9BB5CE',
    '#C2D4E4',
    '#ECF2F7',
    // grayscale
    '#0a0a0a',
    '#171717',
    '#262626',
    '#404040',
    '#525252',
    '#737373',
    '#a3a3a3',
    '#d4d4d4',
    '#e5e5e5',
    '#f5f5f5',
    '#fafafa',
  ]
): string => {
  return tinycolor
    .mostReadable(colour, colourList, {
      // fallback to '#fff' or '#000'
      includeFallbackColors: true,
    })
    .toHexString();
};

export const lightenProportionally = (colour: string) => {
  const colourInstance = tinycolor(colour);
  const luminance = colourInstance.getLuminance(); // 0 = black, 1 = white
  let lightenFactor = 5;
  if (luminance <= 0.1) {
    lightenFactor = 60;
  } else if (luminance <= 0.3) {
    lightenFactor = 55;
  } else if (luminance <= 0.5) {
    lightenFactor = 20;
  } else if (luminance <= 0.7) {
    lightenFactor = 10;
  }

  const lightenedColour = colourInstance.lighten(lightenFactor);
  if (lightenedColour.toHex() === 'ffffff') {
    lightenedColour.darken(1);
  }
  return lightenedColour.toHexString();
};

export const isValidColour = (colour: string) => tinycolor(colour).isValid();
